import { GoogleLoginProvider, MicrosoftLoginProvider, SocialAuthService } from '@abacritt/angularx-social-login';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { merge } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonService } from 'src/app/common.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-newlogin',
  standalone: false,
  templateUrl: './userlogin.component.html',
  styleUrl: './userlogin.component.css'
})
export class UserloginComponent implements OnInit {
  loginForm: UntypedFormGroup;
  submitable = false;
  error = '';
  returnUrl: string;
  errorMessage: any;
  load: boolean = false;
  processing: boolean = false;
  isLoggedin?: boolean;
  socialUser: any
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  @ViewChild('gsignin') gsignin: ElementRef<HTMLElement>;
  constructor(private router: Router, private formBuilder: UntypedFormBuilder, private dataservice: CommonService, private _snackBar: MatSnackBar,
    private socialAuthService: SocialAuthService,private dialog: MatDialog) {
    this.dataservice.getData('/api/checkauth').pipe(
      map((res: Response) => (JSON.stringify(res))))
      .subscribe(
        (response) => {
          this.load = false;
          this.router.navigate(['panel/campaigns']);
        },
        (error) => {
          this.load = true;
          if (error.status === 401) {
            localStorage.removeItem('currentUser');
            localStorage.removeItem('userName');
            localStorage.removeItem('otpemail');
          }
        });

    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });
    this.errorMessage = { email: '', password: '' };
    merge(this.frmCtrl.email.statusChanges, this.frmCtrl.password.statusChanges)
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.updateErrorMessage());
  }
  ngOnInit() {
    this.socialAuthService.authState.subscribe((user) => {
      this.socialUser = user;
      this.isLoggedin = user != null;
      console.log(user);
      if(user){

        this.processing = true;
        const data = {
          email: this.socialUser.email,
          fname: this.socialUser.firstName,
          lname: this.socialUser.lastName,
          name: this.socialUser.name,
          code: this.socialUser.provider == 'MICROSOFT'?this.socialUser.response.uniqueId:this.socialUser.id,
          provider: this.socialUser.provider,
        };
        this.dataservice.sendPostRequest('/api/sso', data).pipe(
          map((res: Response) => (JSON.stringify(res))))
          .subscribe(
            (response) => {
              this.processing = false;
              const result = JSON.parse(response);
              console.log(result);
              localStorage.setItem('currentUser', JSON.stringify(result.access_token));
              localStorage.setItem('userName', result.user.name);
              localStorage.setItem('plan', result.active_subscription?.plan??'');
              this.router.navigate(['panel/campaigns']);
            },
            (error) => {
              this.processing = false;
              if (error.status === 401) {
                this.error = error.error.error_message;
                // this.openSnackBar(error.error.error_message,'Dismiss');
              } else {
                this.error = error.error.error_message;
                // this.openSnackBar(error.error.error_message,'Dismiss');
              }
              console.log(error);
            });
      }else{
        localStorage.removeItem('currentUser');
        localStorage.removeItem('userName');
        localStorage.removeItem('plan');
        localStorage.removeItem('otpemail');
        this.router.navigate(['login']);
      }
    });
  }
  get frmCtrl() {
    return this.loginForm.controls;
  }
  /* loginWithGoogle() {
    console.log('Hi');
    let el: HTMLElement = this.gsignin.nativeElement;
    el.click();
  } */
  signInWithMicrosoft(): void {
    this.socialAuthService.signIn(MicrosoftLoginProvider.PROVIDER_ID);
  }
  onSubmit() {
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    } else {
      this.processing = true;
      const data = {
        email: this.frmCtrl.email.value,
        password: this.frmCtrl.password.value,
      };
      this.dataservice.sendPostRequest('/api/login', data).pipe(
        map((res: Response) => (JSON.stringify(res))))
        .subscribe(
          (response) => {
            this.processing = false;
            const result = JSON.parse(response);
            console.log(result);
            if(result.user.is2fa){
              this.router.navigate(['verify-otp/' + result.code+'/y']);
            }else{
              localStorage.setItem('currentUser', JSON.stringify(result.access_token));
              localStorage.setItem('userName', result.user.name);
              localStorage.setItem('plan', result.active_subscription?.plan??'');
              this.router.navigate(['panel/campaigns']);
            }
          },
          (error) => {
            this.processing = false;
            if (error.status === 401) {
              this.error = error.error.error_message;
              // this.openSnackBar(error.error.error_message,'Dismiss');
            } else {
              this.error = error.error.error_message;
              // this.openSnackBar(error.error.error_message,'Dismiss');
            }
            console.log(error);
          });
    }
  }
  sendotp() {
    this.load = false;
    const data = {
      mfa_enable: 'y',
    };
    this.dataservice.sendPostRequest('/api/send-otp', data).pipe(
      map((res: Response) => (res)))
      .subscribe(
        (response) => {
          console.log(response);
          this.load = true;
          this.router.navigate(['panel/mfa/l']);
        },
        (error) => {
          this.load = true;
          console.log(error); 
          let err = error.error;
          let thisvar = this;
          Object.keys(err).forEach(key => {
              thisvar._snackBar.open(err[key], '', {
                duration: 3000,
                horizontalPosition: thisvar.horizontalPosition,
                verticalPosition: thisvar.verticalPosition,
              });
          });
        }
      );
  }
  updateErrorMessage() {
    this.submitable = true;

    if (this.frmCtrl.email.hasError('required')) {
      this.errorMessage.email = 'Email is required';
      this.submitable = false;
    } else if (this.frmCtrl.email.hasError('email')) {
      this.errorMessage.email = 'Not a valid email';
      this.submitable = false;
    }

    if (this.frmCtrl.password.hasError('required')) {
      this.errorMessage.password = 'Password is required';
      this.submitable = false;
    } else if (this.frmCtrl.password.hasError('minlength')) {
      this.errorMessage.password = 'Invalid password';
      this.submitable = false;
    }
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action);
  }
}
